import React from 'react';
import { MapPin, Calendar } from 'lucide-react';

interface AnimatronicCardContentProps {
  name: string;
  attraction: string;
  country: string;
  year: number;
}

const AnimatronicCardContent: React.FC<AnimatronicCardContentProps> = ({
  name,
  attraction,
  country,
  year
}) => {
  return (
    <>
      <h3 className="text-lg font-semibold mb-2 text-content-primary group-hover:text-brand transition-colors">
        {name}
      </h3>
      <p className="text-sm text-content-secondary mb-3">
        {attraction}
      </p>
      <div className="flex justify-between text-sm text-content-secondary">
        <div className="flex items-center">
          <MapPin className="w-4 h-4 mr-1.5 text-brand/70" />
          <span>{country}</span>
        </div>
        <div className="flex items-center">
          <Calendar className="w-4 h-4 mr-1.5 text-brand/70" />
          <span>{year}</span>
        </div>
      </div>
    </>
  );
};

export default AnimatronicCardContent;